<template>
  <div class="kiosk-start-order">
    <div v-if="!orderStarted" class="content">
      <div class="btns">
        <button @click="beginOrder('dine-in')">
          <font-awesome-icon icon="fa-utensils" />
          <p>Dine In</p>
        </button>
        <button @click="beginOrder('takeaway')">
          <font-awesome-icon icon="fa-person-running" />
          <p>Takeaway</p>
        </button>
      </div>
    </div>
    <div v-if="orderStarted">
      <div class="back-button" @click.stop.prevent="orderStarted = false">
        <font-awesome-icon icon="fa-arrow-left" />
      </div>
      <div v-if="orderType == 'dine-in'" class="info">
        <h3>Take a table number</h3>
        <h3>enter it below</h3>
        <input type="number" placeholder="Table Number" v-model="tableNo" />
        <button @click.stop.prevent="createOrderDetails">Continue</button>
        <p v-if="errors.error" class="error">{{ errors.msg }}</p>
      </div>
      <div v-if="orderType == 'takeaway'" class="info">
        <h3>Enter a name for the order</h3>
        <input type="text" placeholder="Order Name" v-model="orderName" />
        <button @click.stop.prevent="createOrderDetails">Continue</button>
        <p v-if="errors.error" class="error">{{ errors.msg }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "StartOrder",
  components: {},
  data() {
    return {
      orderStarted: false,
      orderType: "",
      tableNo: "",
      orderName: "",
      orderDetails: {},
      errors: {
        error: false,
        msg: "",
      },
    };
  },

  computed: {
    ...mapGetters({
      loading: "loading",
      socketConnected: "socketConnected",
      getKiosk: "getKiosk",
    }),
  },

  methods: {
    beginOrder(type) {
      this.orderType = type;
      this.orderStarted = true;
    },

    createOrderDetails() {
      if (this.orderType === "dine-in" && this.tableNo) {
        this.orderDetails = { orderType: "dine-in", orderDetails: this.tableNo };
      } else if (this.orderType === "takeaway" && this.orderDetails) {
        this.orderDetails = { orderType: "takeaway", orderDetails: this.orderName };
      } else {
        this.errors = {
          error: true,
          msg: "Please fill in the required fields to continue",
        };
        return;
      }
      this.$store.dispatch("setKioskDetails", this.orderDetails);
      this.$router.push("/store");
    },
  },

  watch: {
    getKiosk() {
      if (!this.getKiosk) {
        this.$router.push({ path: "/store" });
      }
    },
  },
};
</script>

<style scoped lang="scss">
.kiosk-start-order {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;
  background: var(--primary-colour);
  color: var(--text-colour);
  position: absolute;
  width: 100%;
  height: 100%;
  background-image: url("/startOrderAssests/BagelsVectorisedLight.png");
  background-size: cover;
  background-position: center;
}

.back-button {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: var(--primary-colour);
  color: var(--action-colour);
  font-size: 2rem;
  cursor: pointer;
  padding: 1rem;
  margin: 1rem 0;
  border-radius: 1rem;
}

.error {
  color: var(--warning-colour);
  font-size: 1.5rem;
  margin-top: 1rem;
}

.content {
  position: relative;
  z-index: 1;
  text-align: center;
  color: var(--secondary-text-colour);
  font-weight: 900;
  padding: 3rem 2rem;
  border-radius: 16px;
}

.info {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: var(--primary-colour);
  color: var(--text-colour);
  font-size: 2rem;
  font-weight: bold;
  border-radius: 20px;
  padding: 2rem;
  h3 {
    margin: 0;
  }
  input {
    width: 20rem;
    padding: 1rem;
    font-size: 1.5rem;
    border: none;
    border-radius: 8px;
    margin-top: 2rem;
    box-shadow: var(--box-shadow);
  }
  button {
    background-color: var(--secondary-colour);
    color: var(--action-colour);
    width: 22rem;
    padding: 1rem 3rem;
    &:active {
      scale: 0.95;
    }
  }
}

.btns {
  display: flex;
  gap: 1rem;
  button {
    width: 25rem;
    p {
      margin: 0;
      font-size: 2rem;
      font-weight: 900;
    }
  }
}

button {
  margin-top: 2rem;
  padding: 1.5rem 3rem;
  font-size: 2rem;
  border: none;
  border-radius: 8px;
  background: var(--primary-colour);
  box-shadow: var(--box-shadow);
  color: var(--text-colour);
  cursor: pointer;
  &:active {
    scale: 0.95;
  }
}
</style>
